import { ActionTypes } from "../constants";

const reduceActivities = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.GET_ACTIVITIES_SUCCESS:
            return action.data;

        case ActionTypes.GET_ACTIVITY_SUCCESS:
            return [
                ...(state || []).filter(({id}) => id !== action.data.id),
                action.data
            ];

        case ActionTypes.ADD_ACTIVITY_SUCCESS:
            return !state ? [action.data] : [...state, action.data];

        case ActionTypes.UPDATE_ACTIVITY_SUCCESS:
            return [
                ...state.filter(({id}) => Number(id) !== Number(action.payload.id)),
                {
                    ...(state.find(({id}) => Number(id) === Number(action.payload.id))),
                    ...action.payload.params
                }
            ];

        case ActionTypes.DELETE_ACTIVITY_SUCCESS:
            const activityId = Number(action.payload.id);
            return (state || []).filter(({id}) => Number(id) !== activityId);

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceActivities;
export const getActivity = (activities, activityId) => !activities ? null : activities.find(({id}) => id === activityId);
export const getActivities = (activities) => activities || [];
